import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const show = useCallback((message, kind = "info") => {
    const id = Date.now() + Math.random();
    setToasts((p) => [...p, { id, message: String(message), kind }]);
    setTimeout(() => setToasts((p) => p.filter((t) => t.id !== id)), 3200);
  }, []);
  const value = useMemo(() => ({ show }), [show]);
  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="pointer-events-none fixed inset-x-0 top-6 z-[9999] flex flex-col items-center gap-2 px-4" data-testid="toast-host">
        {toasts.map((t) => (
          <div
            key={t.id}
            data-testid="toast-message"
            className={`toast-in max-w-[90%] rounded-[10px] px-4 py-3 text-sm font-semibold text-white shadow-[0_6px_12px_rgba(0,0,0,0.18)] sm:max-w-md ${
              t.kind === "success" ? "bg-a-success" : t.kind === "error" ? "bg-a-danger" : "bg-a-primary"
            }`}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const v = useContext(ToastCtx);
  if (!v) throw new Error("useToast must be used within ToastProvider");
  return v;
}
